import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DASHBOARD_CONSTANTS, DATE_FILTERS } from '../../shared/constants/constants';
import dayjs from 'dayjs';

interface DashboardState {
    selectedTab: string;
    currentPage: number;
    pageSize: number;
    sortField: string;
    sortOrder: 'asc' | 'desc';
    searchText: string;
    filters: string;
    dateSpan: {
        type: string;
        startDate: any;
        endDate: any;
    };
}

const initialState: DashboardState = {
    selectedTab: DASHBOARD_CONSTANTS.TABS.ORDERS,
    currentPage: 1,
    pageSize: 10,
    sortField: 'createdDate',
    sortOrder: 'desc',
    searchText: '',
    filters: '',
    dateSpan: {
        type: DATE_FILTERS["ALL"].value,
        startDate: dayjs(new Date()).toString(),
        endDate: dayjs(new Date()).toString()
    }
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setSelectedTab(state, action: PayloadAction<string>) {
            state.selectedTab = action.payload;
        },
        setPagination(state, action: PayloadAction<{ currentPage: number; pageSize: number }>) {
            state.currentPage = action.payload.currentPage;
            state.pageSize = action.payload.pageSize;
        },
        setSelectedSort(state, action: PayloadAction<{ sortField: string; sortOrder: 'asc' | 'desc' }>) {
            state.sortField = action.payload.sortField;
            state.sortOrder = action.payload.sortOrder;
        },
        setFilters(state, action: PayloadAction<string>) {
            state.filters = action.payload;
        },
        setStoreSearchText(state, action: PayloadAction<string>) {
            state.searchText = action.payload;
        },
        setDateSpanRedux(state, action: PayloadAction<any>) {
            state.dateSpan = {
                type: action.payload.type,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate
            }
        },
        resetDashboardState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase("RESET_ALL", (state, action) => {
                return initialState;
            })
    }
},
);

export const { setSelectedTab, setPagination, setSelectedSort, setFilters, setStoreSearchText, setDateSpanRedux, resetDashboardState } = dashboardSlice.actions;
export default dashboardSlice.reducer;